import { Controller } from "@hotwired/stimulus"

// Toggles the sidebar. basecoat's own sidebar script listens for this event on
// the document, so both the button inside the sidebar and the floating one that
// appears when it is collapsed dispatch it.
export default class extends Controller {
	toggle() {
		document.dispatchEvent(new CustomEvent("basecoat:sidebar"))
	}
}
